import { z } from 'zod'

import type { Notification } from '../schemas/public/Notification.js'
import { notification } from '../schemas/public/Notification.js'
import type { OrganizationId } from '../schemas/public/Organization.js'
import { organizationId } from '../schemas/public/Organization.js'
import type { ProjectId } from '../schemas/public/Project.js'
import { projectId } from '../schemas/public/Project.js'
import type { UserId } from '../schemas/public/User.js'
import { userId } from '../schemas/public/User.js'

export type ExtendedNotification = Omit<
  Notification,
  'createdBy' | 'updatedAt' | 'updatedBy' | 'deletedBy'
> & {
  cableSerial?: number | null
  loggerSerial?: string | null
  organizationName?: string | null
  organizationId?: OrganizationId | null
  projectName?: string | null
  projectId?: ProjectId | null
  resolvedByUser?: {
    id: UserId
    nameFirst?: string | null
    nameLast?: string | null
  } | null
}

const joinedFields = z.object({
  cableSerial: z.number().nullable().optional(),
  loggerSerial: z.string().nullable().optional(),
  organizationName: z.string().nullable().optional(),
  organizationId: organizationId.nullable().optional(),
  projectName: z.string().nullable().optional(),
  projectId: projectId.nullable().optional(),
  resolvedByUser: z
    .object({
      id: userId,
      nameFirst: z.string().nullable().optional(),
      nameLast: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
})

export const extendedNotification = (
  notification as unknown as z.ZodObject<any>
)
  .omit({
    createdBy: true,
    updatedAt: true,
    updatedBy: true,
    deletedBy: true,
  })
  .extend(joinedFields.shape) as unknown as z.Schema<ExtendedNotification>
